module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-form-file', {
    staticStyle: {
      "height": "80px",
      "background": "darkgray",
      "width": "600px"
    },
    attrs: {
      "otherDocName": _vm.otherDocName,
      "documentLink": _vm.documentLink,
      "folderName": 'Expense',
      "accept": '*',
      "id": "MultiFileUploader",
      "documentName": _vm.documentName,
      "multiple": _vm.multiple,
      "fileAllModuleId": _vm.fileAllModuleId,
      "assign_no": _vm.assign_no,
      "drop-placeholder": "Drop file here...",
      "plain": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _vm._l((_vm.uploadedFiles), function(ufile, uindex) {
    return _c('div', {
      key: uindex
    }, [(_vm.assign_no) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/" + _vm.doc_path + '/' + ufile,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("--View Document - " + _vm._s(uindex + 1))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: index
    }, [_c('div', [_vm._v(_vm._s(file.name))]), _vm._v(" "), (file.progress > 0) ? _c('b-progress', {
      staticClass: "custom-progress-bar",
      attrs: {
        "variant": 'success',
        "value": file.progress,
        "max": 100,
        "show-progress": "",
        "animated": ""
      }
    }, [_c('b-progress-bar', {
      attrs: {
        "value": file.progress,
        "max": 100,
        "variant": "success",
        "striped": ""
      }
    }, [_vm._v("\n        " + _vm._s(file.progress) + "%\n      ")])], 1) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503c210f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/ClientFileUploader.vue
// module id = 2621
// module chunks = 0